import { render, staticRenderFns } from "./oprobitRes.vue?vue&type=template&id=503ff975&scoped=true&"
import script from "./oprobitRes.vue?vue&type=script&lang=js&"
export * from "./oprobitRes.vue?vue&type=script&lang=js&"
import style0 from "./oprobitRes.vue?vue&type=style&index=0&id=503ff975&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ff975",
  null
  
)

export default component.exports